// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_iwI","cls2":"PaperBrowserPreviewList-cls2_X0T PaperBrowserPreviewList-cls1_iwI"};